/**
 * LP why-choose-us carousel (sections/medispa-lp-why-choose-us.liquid).
 * Loaded by deferred-scripts.liquid (marker: medispa-why-choose-us).
 */
import { medispaCarousels, whenSwiperReady } from '@/components/utils/medispa-lp';

whenSwiperReady(() => {
  const slider = document.querySelector<HTMLElement>('.slider-wrapper.swiper');
  if (!slider) return;

  medispaCarousels()['why-choose-us'] = new window.Swiper(slider, {
    slidesPerView: 'auto',
    centeredSlides: true,
    // Every slide carries its own .swiper-pagination element; without this,
    // Swiper reduces a multi-element match to the first one. Root-level param
    // in Swiper 11 (the pagination module reads params.uniqueNavElements).
    uniqueNavElements: false,
    pagination: {
      el: '.medispa-why-choose-us .swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.medispa-why-choose-us .swiper-button-next',
      prevEl: '.medispa-why-choose-us .swiper-button-prev',
    },
  });
});
